import { Backend } from '@/_axios';

export default {
  list(projectId, params) {
    return Backend.get(`/project/${projectId}/detection_sets/`, { params, cancelDuplicates: true });
  },
  createData(projectId) {
    return Backend.get(`/project/${projectId}/detection_sets/create`);
  },
  editData(projectId, id) {
    return Backend.get(`/project/${projectId}/detection_sets/${id}/edit`);
  },
  create(projectId, data) {
    return Backend.post(`/project/${projectId}/detection_sets/`, data);
  },
  update(projectId, data) {
    return Backend.put(`/project/${projectId}/detection_sets/${data.id}`, data);
  },
  delete(projectId, id, params) {
    return Backend.delete(`/project/${projectId}/detection_sets/${id}`, { params });
  },
  getForDelete(projectId, id) {
    return Backend.get(`/project/${projectId}/detection_sets/${id}/get_for_delete`);
  },
};
